
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.083 7h7.711c.385 0 .622-.415.401-.731C17.257 2.056 11.53.724 7 3.339a10.03 10.03 0 00-1.853 1.375c-.319.3-.368.78-.15 1.158l1.904 3.297c.206.357.748.33.982-.009A4.98 4.98 0 019.5 7.67 4.977 4.977 0 0112.083 7zM10.195 21.126c-.218.378-.658.576-1.077.45A9.965 9.965 0 013.34 17a9.988 9.988 0 01-.401-9.233c.163-.349.64-.351.833-.018l3.89 6.739.008.012a4.994 4.994 0 003.93 2.485c.41.033.704.49.498.846l-1.903 3.295zM12 9a3 3 0 00-2.604 4.49l.006.01a3 3 0 005.167.05l.03-.05a2.998 2.998 0 00-2.55-4.5H12zM12.431 21.253c-.192.333.049.745.432.712A9.963 9.963 0 0017 20.66c3.915-2.26 5.724-6.768 4.736-10.953-.1-.425-.491-.707-.928-.707H16.6c-.247 0-.394.286-.27.5a4.999 4.999 0 01-.048 5.083l-3.85 6.67z"}})])
          )
        }
      }
    